import React from 'react';

const productsData = [
  // Machine Room Less Elevators
  {
      id: 1,
      name: "Panoramic Glass MRL Elevator",
      description: "Luxury machine-room-less elevator with panoramic glass design. Features silent operation, energy efficiency and customizable interior lighting.",
      image: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753224340/0b3d1079-a803-4b61-b0b6-4f529117a9ea_tgn0vw.png",
      category: "machine-room-less",
      isFeatured: true,
      specs: {
          capacity: "450 kg",
          speed: "1 m/s",
          floors: "2-4",
          dimensions: "1.1m × 1.4m"
      }
  },
  {
      id: 2,
      name: "Compact MRL Home Elevator",
      description: "Space-saving machine-room-less residential elevator solution with minimal shaft requirements. Energy-efficient with low maintenance.",
      image: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753223873/HomeElevator_uokcyh.jpg",
      category: "machine-room-less",
      isFeatured: true,
      specs: {
          capacity: "320 kg",
          speed: "0.7 m/s",
          floors: "2-3",
          dimensions: "0.9m × 1.2m"
      }
  },
  {
      id: 3,
      name: "Premium MRL Villa System",
      description: "High-end machine-room-less elevator with premium materials and smart home integration. Perfect for luxury residences.",
      image: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753223877/PremiumVillaElevator_nry2qy.png",
      category: "machine-room-less",
      isFeatured: true,
      specs: {
          capacity: "550 kg",
          speed: "1.2 m/s",
          floors: "2-6",
          dimensions: "1.2m × 1.6m"
      }
  },

  // Hydraulic Elevators
  {
      id: 4,
      name: "Commercial Hydraulic Elevator",
      description: "Smooth and reliable hydraulic elevator system for office buildings. Features quiet operation and excellent ride comfort.",
      image: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753223898/OfficeElevator_dbdvo2.jpg",
      category: "hydraulics",
      isFeatured: true,
      specs: {
          capacity: "1200 kg",
          speed: "0.8 m/s",
          floors: "2-8",
          dimensions: "2.0m × 1.8m"
      }
  },
  {
      id: 5,
      name: "Heavy-Duty Hydraulic System",
      description: "Robust hydraulic elevator designed for high-traffic environments like shopping centers. Offers exceptional reliability and smooth starts/stops.",
      image: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753223902/ShoppingMallElevator_xazdnw.png",
      category: "hydraulics",
      isFeatured: true,
      specs: {
          capacity: "1500 kg",
          speed: "0.7 m/s",
          floors: "2-6",
          dimensions: "2.2m × 2.0m"
      }
  },
  {
      id: 6,
      name: "Luxury Hydraulic Elevator",
      description: "Premium hydraulic elevator system combining excellent ride quality with stylish design. Ideal for hotels and upscale properties.",
      image: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753223905/HotelGuestElevator_d9lupy.jpg",
      category: "hydraulics",
      isFeatured: true,
      specs: {
          capacity: "1000 kg",
          speed: "0.6 m/s",
          floors: "2-6",
          dimensions: "1.8m × 1.7m"
      }
  },

  // Vehicle Lifts (Former Industrial Elevators)
  {
      id: 7,
      name: "Industrial Vehicle Lift",
      description: "Heavy-duty vehicle lift system designed for moving cars, trucks and other vehicles between floors. Features reinforced platform and high capacity.",
      image: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753223919/FreightElevator_ux7u6p.png",
      category: "vehicle-lift",
      isFeatured: true,
      specs: {
          capacity: "5000 kg",
          speed: "0.8 m/s",
          floors: "2-10",
          dimensions: "3.0m × 3.5m"
      }
  },
  {
      id: 8,
      name: "Warehouse Vehicle Lift",
      description: "Specialized vehicle lift designed for logistics centers and warehouses. Features include wide platform and robust loading capacity.",
      image: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753223927/WhereHouseCargoLiftImg_ogkvxv.png",
      category: "vehicle-lift",
      isFeatured: true,
      specs: {
          capacity: "4000 kg",
          speed: "0.6 m/s",
          floors: "2-6",
          dimensions: "2.8m × 3.2m"
      }
  },
  {
      id: 9,
      name: "Heavy Machinery Vehicle Lift",
      description: "Extra large capacity vehicle lift designed for transporting heavy equipment, forklifts and industrial machinery between floors.",
      image: "https://res.cloudinary.com/dknsjvavr/image/upload/v1753223924/HeavyMachineryElevatorImg_tmj7kr.png",
      category: "vehicle-lift",
      isFeatured: true,
      specs: {
          capacity: "10000 kg",
          speed: "0.5 m/s",
          floors: "2-8",
          dimensions: "4.0m × 5.0m"
      }
  }
 
];

export default productsData;